(function () {
    'use strict';

    function clampPerPage(value, slideCount) {
        const parsed = parseInt(value, 10);
        const perPage = Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
        return Math.max(1, Math.min(perPage, Math.max(1, slideCount)));
    }

    function equalizeTestimonialHeights(slider) {
        const cards = slider.querySelectorAll('.testimonial-card');
        if (!cards.length) {
            return;
        }

        cards.forEach(function (card) {
            card.style.height = 'auto';
        });

        let maxHeight = 0;
        cards.forEach(function (card) {
            maxHeight = Math.max(maxHeight, Math.ceil(card.getBoundingClientRect().height));
        });

        cards.forEach(function (card) {
            card.style.height = maxHeight + 'px';
        });
    }

    function initTestimonialsSliders() {
        const sliders = document.querySelectorAll('.clients-testimonials .splide');

        sliders.forEach(function (slider) {
            if (slider.classList.contains('is-initialized') || typeof Splide === 'undefined') {
                return;
            }

            const slideCount = slider.querySelectorAll('.splide__slide').length;
            let options = {
                type: 'slide',
                rewind: slideCount > 1,
                omitEnd: true,
                perPage: 3,
                perMove: 1,
                gap: '2rem',
                arrows: true,
                pagination: true,
                autoplay: false,
                pauseOnHover: true,
                drag: slideCount > 1,
                breakpoints: {
                    1024: {
                        perPage: 2,
                        gap: '1.5rem'
                    },
                    576: {
                        perPage: 1,
                        gap: '1rem'
                    }
                }
            };

            if (slider.dataset.splide) {
                try {
                    options = Object.assign(options, JSON.parse(slider.dataset.splide));
                } catch (parseError) {
                    // Keep defaults when custom options are invalid.
                }
            }

            options.type = 'slide';
            options.perPage = clampPerPage(options.perPage || 3, slideCount);
            options.breakpoints = options.breakpoints || {};
            Object.keys(options.breakpoints).forEach(function (bp) {
                options.breakpoints[bp] = Object.assign({}, options.breakpoints[bp]);
                if (options.breakpoints[bp].perPage) {
                    options.breakpoints[bp].perPage = clampPerPage(options.breakpoints[bp].perPage, slideCount);
                }
            });
            options.arrows = !!(options.arrows && slideCount > options.perPage);
            options.pagination = !!(options.pagination && slideCount > options.perPage);
            options.drag = slideCount > options.perPage;

            const splide = new Splide(slider, options);

            function syncHeights() {
                window.requestAnimationFrame(function () {
                    equalizeTestimonialHeights(slider);
                });
            }

            splide.on('mounted', syncHeights);
            splide.on('resized', syncHeights);
            splide.on('updated', syncHeights);
            splide.on('move', syncHeights);
            splide.on('moved', syncHeights);

            splide.mount();
            slider.classList.add('is-initialized');
            syncHeights();
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTestimonialsSliders);
    } else {
        initTestimonialsSliders();
    }

    window.addEventListener('load', initTestimonialsSliders);
})();
